import React from 'react';
import Totals from './Totals';
import ServicesChartsDataProvider from './contexts/ServicesChartsDataContext';

const TotalsWrapper = () => {
    return (
        <ServicesChartsDataProvider
            module={{
                sectionTitle: 'do Total de Pemanência e Acomodação'
            }}
        >
            <Totals />
        </ServicesChartsDataProvider>
    );
};

export default TotalsWrapper;
